import api from '../../../services/api';
import {
  WhatsAppCampaignPayload,
  WhatsAppCampaignPreview,
  WhatsAppCampaignSendResult,
  WhatsAppTemplate,
} from '../types';

export async function getWhatsAppTemplates(): Promise<WhatsAppTemplate[]> {
  const response = await api.get<WhatsAppTemplate[]>('/whatsapp-campaigns/templates');
  return response.data;
}

export async function createWhatsAppTemplate(
  title: string,
  message: string,
): Promise<WhatsAppTemplate> {
  const response = await api.post<WhatsAppTemplate>('/whatsapp-campaigns/templates', {
    title,
    message,
  });
  return response.data;
}

export async function deleteWhatsAppTemplate(id: number): Promise<void> {
  await api.delete(`/whatsapp-campaigns/templates/${id}`);
}

export async function previewWhatsAppCampaign(
  payload: WhatsAppCampaignPayload,
): Promise<WhatsAppCampaignPreview> {
  const response = await api.post<WhatsAppCampaignPreview>(
    '/whatsapp-campaigns/preview',
    payload,
  );
  return response.data;
}

export async function sendWhatsAppCampaign(
  payload: WhatsAppCampaignPayload,
): Promise<WhatsAppCampaignSendResult> {
  const response = await api.post<WhatsAppCampaignSendResult>(
    '/whatsapp-campaigns/send',
    payload,
  );
  return response.data;
}
